/* import __COLOCATED_TEMPLATE__ from './bracket-config-editor-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class BracketConfigEditorCardComponent extends Component
{
	@action updateType(event)
	{
		const newType = event.target.value;
		const updated = { ...this.args.card, type: newType };
		// Reset class groups based on type
		if (newType === 'FIS' || newType === 'FIS50') {
			updated.quarterfinalsClassGroups = updated.quarterfinalsClassGroups || [];
			updated.semifinalsClassGroups = updated.semifinalsClassGroups || [];
			updated.finalsClassGroups = updated.finalsClassGroups || [];
		} else {
			// FISJr and NENSAU16 don't have quarterfinals
			delete updated.quarterfinalsClassGroups;
			updated.semifinalsClassGroups = updated.semifinalsClassGroups || [];
			updated.finalsClassGroups = updated.finalsClassGroups || [];
		}
		this.args.onUpdate(updated);
	}

	@action updateName(event)
	{
		this.args.onUpdate({ ...this.args.card, name: event.target.value });
	}

	@action updateShowBFinal(event)
	{
		this.args.onUpdate({ ...this.args.card, showBFinal: event.target.checked });
	}

	@action updateClassGroups(field, event)
	{
		// Parse comma-separated class group IDs
		const value = event.target.value;
		const classGroups = value.split(',').map(s => s.trim()).filter(s => s);
		this.args.onUpdate({ ...this.args.card, [field]: classGroups });
	}

	get quarterfinalsClassGroupsString()
	{
		return (this.args.card.quarterfinalsClassGroups || []).join(', ');
	}

	get semifinalsClassGroupsString()
	{
		return (this.args.card.semifinalsClassGroups || []).join(', ');
	}

	get finalsClassGroupsString()
	{
		return (this.args.card.finalsClassGroups || []).join(', ');
	}
}
